import {useEffect, useRef, useState} from "react"
import {colorsProgressBar} from "../../pages/planning/components/functions"

export default function SumWatcher({ show, totalSum, deadlines }) {
  const countRef = useRef(null)
  const barRef = useRef(null)
  const [leftPosition, setLeftPosition] = useState(0)

  const updatePosition = () => {
    if (countRef.current && barRef.current) {
      const barWidth = barRef.current.offsetWidth
      const countWidth = countRef.current.offsetWidth
      let left = (barWidth * (Math.min(totalSum, 100) / 100)) - (countWidth / 2)
      left = Math.max(0, Math.min(left, barWidth - countWidth))
      setLeftPosition(left)
    }
  }

  useEffect(() => {
    updatePosition()
    window.addEventListener("resize", updatePosition)
    return () => window.removeEventListener("resize", updatePosition)

    // eslint-disable-next-line
  }, [totalSum])

  if (!show) return null

  return (
    <div
      className={
        "watch-progress-bar " +
        (totalSum !== 0 && totalSum !== 100 ? "invalid" : "")
      }
    >
      <span
        ref={countRef}
        className="watch-progress-bar__count"
        style={{ left: `${leftPosition}px` }}
      >
        {totalSum}%
      </span>
      <div ref={barRef} className="watch-progress-bar__bar">
        {deadlines
          .filter(item => item.value > 0)
          .map((item, idx) => {
            const percent = Number(item.value)
            const scaledPercent = totalSum > 100 ? (percent / totalSum) * 100 : percent
            return (
              <div
                key={idx}
                className="watch-progress-bar__bar--item"
                style={{
                  width: `${scaledPercent}%`,
                  background: colorsProgressBar[item.order]?.background,
                  color: colorsProgressBar[item.order]?.bar,
                }}
              >
                {percent}%
              </div>
            )
          })}
      </div>
      <div className="watch-progress-bar__limits">
        <span>0%</span>
        <span>100%</span>
      </div>
      <p className="watch-progress-bar__text">
        A soma dos percentuais informados <strong>deve ser igual a 100%</strong>
      </p>
    </div>
  )
}
